export default __webpack_public_path__ + "static/media/c9.b59ea8af.png";